import { useMemo, useCallback } from 'react';
import encarUrlBuilder from 'app/libs/encarUrlBuilder';
import { useSsrRequest } from 'app/context/common/SsrRequestProvider';
import { isServer } from 'app/libs/environment';

function useEncarUrlBuilder() {
	const req = useSsrRequest();
	const navigator = useMemo(
		() => (isServer ? { userAgent: req.headers['user-agent'], language: req.headers['accept-language'] } : window.navigator),
		[req],
	);

	return useCallback(() => encarUrlBuilder(navigator), [navigator]);
}

export default useEncarUrlBuilder;
